import React from 'react';
import { Card } from '../ui/Card';
export function MapLegend() {
  return <Card className="absolute bottom-6 left-6 z-[400] w-64 !p-4 shadow-float border-0 bg-white/95 backdrop-blur-sm" data-id="element-60">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-61">
        Bewertungs-Score
      </h4>

      <div className="space-y-3" data-id="element-62">
        <div className="flex items-center justify-between" data-id="element-63">
          <div className="flex items-center gap-2" data-id="element-64">
            <div className="w-3 h-3 rounded-full bg-status-success shadow-[0_0_8px_rgba(34,197,94,0.4)]" data-id="element-65"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-66">
              Exzellent (&gt;4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-67">842</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-68">
          <div className="flex items-center gap-2" data-id="element-69">
            <div className="w-3 h-3 rounded-full bg-status-warning shadow-[0_0_8px_rgba(234,179,8,0.4)]" data-id="element-70"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-71">
              Durchschnitt (3.5-4.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-72">126</span>
        </div>

        <div className="flex items-center justify-between" data-id="element-73">
          <div className="flex items-center gap-2" data-id="element-74">
            <div className="w-3 h-3 rounded-full bg-status-danger shadow-[0_0_8px_rgba(239,68,68,0.4)]" data-id="element-75"></div>
            <span className="text-sm font-medium text-gray-700" data-id="element-76">
              Kritisch (&lt;3.5)
            </span>
          </div>
          <span className="text-xs font-bold text-gray-900" data-id="element-77">12</span>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100" data-id="element-78">
        <div className="text-xs text-gray-500" data-id="element-79">
          <span className="font-medium text-edeka-blue" data-id="element-80">12 Märkte</span> im
          kritischen Bereich erfordern Aufmerksamkeit.
        </div>
      </div>
    </Card>;
}